<script>
import { merchantComputed } from '@state/helpers'
import lazyLoadComponent from '@router/lazyload-component'
const initData = (title) => {
  return {
    title,
    isEnabled: '',
    terms: '',
    canUseUnPaidPrepaid: 1
  }
}
export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitData: Object.assign({}, initData(`${this.$t('prepaid.BASE')}方案`), this.defaultValue),
      createLoading: false,
    }
  },
  computed: {
    ...merchantComputed,
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入選單名稱',
          },
        ],
        terms: [
          {
            required: true,
            message: '請輸入契約條款',
          },
        ],
      }
    },
    fromatPrapaidTerms() {
      return `${this.currentMerchant.name || '店家'}${this.submitData.title || this.$t('prepaid.BASE')}方案使用注意事項

${this.currentMerchant.name || '店家'}（後稱「本店」）提供「${this.submitData.title || this.$t('prepaid.BASE')}方案消費方式」（後稱「本服務」）予本店會員使用，以下為本服務使用規則說明：

一. 認知與接受條款
當會員臨櫃或透過線上系統購買本服務，表示會員已閱讀、瞭解並同意接受本合約所載條款。若會員不同意下述之任何條款，請勿使用本方案。本店得隨時修改或變更本合約之條款並於${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台公告，如會員於前開修改或變更後繼續持本服務消費時，視為會員已閱讀、瞭解並同意接受該等修改或變更。

二. 使用方式
1. 本服務僅限本店會員臨櫃購買及透過${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台辦理線上購買方案，購買時依照議定金額開立收據或發票。
2. 使用本服務方案折抵消費時，若當次消費金額超出折抵額時，應以其他方式進行付款。
3. 若使用本服務方案折抵後需辦理取消訂單或退貨時，將未使用的次數退回至會員本服務之方案中。
4. 會員得臨櫃申辦本服務單一方案之全部（而非部分）餘額退費，會員可至本店臨櫃或${this.$t('APP_NAME')}${this.$t('APP_SUBNAME')}平台線上查詢方案剩餘次數及內容，退款可退回扣除消費金額後之實際支付金額，方案優惠贈送額度次數及內容恕無法折現退還。
5. 各案如設有期限為優惠價格實施期限，如需逾時使用，可能會產生額外費用；方案優惠贈送額度次數及內容逾時則不得折抵兌換。
6. 本服務適用之項目依照各方案說明頁可折抵項目為主，變更時將不另行通知。
`
    },
  },
  async created() {
    this.createLoading = true
    await this.getService()
    this.createLoading = false
  },
  methods: {
    onClickLeave() {
      this.submitData = Object.assign({}, initData(`${this.$t('prepaid.BASE')}方案`), this.defaultValue)
      this.$emit('leave')
    },
    setDefaultContact() {
      this.submitData.terms = this.fromatPrapaidTerms
    },
    /**
     * @description 基本設定 -> 取得
     */
    async getService() {
      const { response } = await this.$store.dispatch(
        'merchant/getCosmeticBasicSet',
        {
          "type": "prepaid",
        }
      )
      this.submitData = { ...response.items }
      this.composeInitSubmitData()
    },
    /**
     * @description 組成初始submit資料（for bannerImages
     */
    composeInitSubmitData() {
      try {
        const { bannerImages } = this.submitData
        this.$set(this.submitData, 'bannerImage', bannerImages[0]?.path || '')
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成bannerImage資料
     */
    composeBannerImage() {
      const { bannerImage, ...others } = this.submitData
      this.submitData = {
        ...others,
        bannerImages: bannerImage === '' ? [] : [
          {
            path: bannerImage ?? '',
            default: 0
          }
        ],
      }
    },
    /**
     * @description 基本設定 -> 儲存
     */
    async tryToStore() {
      this.composeBannerImage()
      await this.$refs.form.validate()
      const { response } = await this.$store.dispatch(
        'merchant/postCosmeticBasicSet',
        {
          "type": "prepaid",
          "payload": this.submitData
        }
      )
      if (response.code === 200) {
        this.$message({
          message: '儲存成功！',
          type: 'success',
        })
        await this.getService()
      }
    },
  },
}
</script>
<template>
  <div :class="$style.basicSetForm">
    <div class="isStylePageContent">
      <el-form ref="form" :rules="formRules" :model="submitData" label-position="top" class="el-form--floating">
        <h4 data-tour-text="" class="form-block-title justify-content-start fs-lg"><span
            class="isStyleRequired">選單名稱</span> <span class="ml-3 text-danger text-secondary fs-sm">此名稱會顯示在前台</span>
        </h4>
        <el-row :gutter="20">
          <el-col :sm="24" :span="24">
            <el-form-item label="" prop="title">
              <el-input v-model="submitData.title" :placeholder="`${$t('prepaid.BASE')}方案`"
                class="bg-white is-border"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="only-bottom-line"></div>
        <el-row :gutter="20" type="flex" justify="space-between" :class="[$style['basicSetForm_rowHeight']]">
          <el-col :md="20" :span="24" class="align-self-center">
            <h3 :class="$style.fontSize">前台是否顯示{{ `${$t('prepaid.BASE')}` }}方案</h3>
          </el-col>
          <el-col :md="4" :span="24">
            <el-form-item label="" prop="isEnabled" class="mb-0">
              <el-switch v-model="submitData.isEnabled" active-text="是" inactive-text="否" :active-value="1"
                :inactive-value="0"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="space-between" :class="[$style['basicSetForm_rowHeight']]">
          <el-col :span="20">
            <h3 :class="$style.fontSize">是否開放{{ `${$t('prepaid.BASE')}` }}方案未付款可抵扣預約</h3>
          </el-col>
          <el-col :span="4">
            <el-switch v-model="submitData.canUseUnPaidPrepaid" active-text="是" inactive-text="否" :active-value="1"
              :inactive-value="0" change="changeFrontDesk"></el-switch>
          </el-col>

        </el-row>
        <div class="only-bottom-line"></div>
        <el-row v-if="!$isIpetBooking()">
          <el-col :sm="24" :span="24">
            <h4 data-tour-text="">Banner圖片</h4>
            <el-form-item prop="images" label="">
              <BaseUpload v-if="submitData" v-model="submitData.bannerImage" :display-column="true" :width-full="true"
                is-between is-deposit dir="/deposit" suggest-size="1920/248" resource="deposit" type="custom" />
            </el-form-item>
            <el-divider></el-divider>
          </el-col>
        </el-row>

        <h4 class="form-block-title isStyleBasicTitle fs-lg">{{ `${$t('prepaid.BASE')}` }}方案定型化契約</h4>
        <el-row :gutter="20" type="flex" justify="space-between" :class="[$style['basicSetForm_inputContract']]">
          <el-form-item label="" prop="terms" class="mb-0 w-100">
            <div>
              <span :class="$style.label" class="text-secondary">
                契約內容
              </span>
              <el-button class="is-round mb-3" @click="setDefaultContact">引用系統提供的{{ `${$t('prepaid.BASE')}`
              }}方案定型化契約</el-button>
            </div>
            <el-input v-model="submitData.terms" type="textarea" :autosize="{ minRows: 7 }"
              class="bg-white is-round is-border" />
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button :loading="createLoading" class="is-round" type="primary" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.basicSetForm {
  padding-bottom: 8rem;

  :global {
    .form-block-title {}
  }

  &_rowHeight {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.7rem 0;

    :global {
      .el-col {
        &:not(:first-child) {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  &_inputPart {
    flex-direction: column;

    &_slider {
      padding-left: 10px;
    }
  }

  &_inputContract {
    margin-top: 12px;
    padding-left: 10px;
    padding-right: 10px;

    .label {
      padding-right: 10px;

      &:after {
        content: ' *';
        color: red;
      }
    }

    >el-input {
      height: 176px;
    }
  }
}

.fontSize {
  font-size: 16px;
}
</style>
